<template>
    <div id="disputeAssociationModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="disputeAssociationTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="disputeAssociationTitle">Link Dispute to Authorizations</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <div class="input-group input-group-sm mb-1 mr-2">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                            </div>
                            <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                        </div>                     
                    </div>
                    <div>
                        <table class="table table-sm font-smaller mb-3">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Document</th>
                                    <th>Submitted</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="filteredDocuments.length">
                                    <tr v-for="doc in filteredDocuments" :key="'dispute-authorization-' + doc.id">
                                        <td class="fit">
                                            <div class="custom-control custom-checkbox">
                                                <input :id="'dispute-authorization-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected">
                                                <label class="custom-control-label align-top" :for="'dispute-authorization-checkbox-' + doc.id">
                                                    <span class="sr-only"></span>
                                                </label>
                                            </div>                                       
                                        </td>
                                        <td>
                                            <document-status-icon class="icon-small" :document-id="doc.id" :document-status="doc.document_status"></document-status-icon>                                         
                                            <span :title="doc.document_type.name + ' - ' + doc.description">{{ doc.document_type.name }} - {{ doc.description | truncate(70) }}</span>
                                        </td>
                                        <td class="fit">{{ doc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss')  }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr><td class="text-center text-muted" colspan="3"><h5>No Disputable Authorizations</h5></td></tr>
                                </template>
                            </tbody>
                        </table>
                    </div>                    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="associate()">Link</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import DocumentStatusIcon from './DocumentStatusIconComponent.vue';

export default {
    components: {
        DocumentStatusIcon
    },
    data() {
        return {
            document: null,
            authorizations: [],
            searchString: ''            
        }
    },
    computed: {
         filteredDocuments: function () {
            const self = this;
             return self.authorizations.filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
         }
    },
    methods: {
        show: function (document) {

            this.document = document;
            axios.get('/ajax/disputes/' + document.id + '/associations')
                .then(response => {

                    let associations = response.data.associations;
                    this.authorizations = response.data.authorizations.map(e => { 
                        let isSelected = associations.some(x => x.id === e.id);
                        this.$set(e, 'selected', isSelected); 
                        return e; 
                    });
                    $('#disputeAssociationModal').modal('show'); 
                })
                .catch(error => {
                    // TODO: handle errors
                    console.log(error);
                });
        },
        associate: function () {

            axios.post('/ajax/disputes/' + this.document.id + '/associate', {
                authorizations: this.authorizations.filter(e => e.selected).map(x => x.id)
            })
            .then(response => {
                $('#disputeAssociationModal').modal('hide');
            })
            .catch(error => {

                // TODO: handle error
                console.log(error);
                $('#disputeAssociationModal').modal('hide');
            });
        }        
    },
    created() {
        eventHub.$on('show-dispute-association', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-dispute-association');
    }        
}
</script>

<style scoped>
    .icon-small {
        font-size: 1em;
    }
</style>